import { add } from "lodash";
import _ from "../../../../@lodash";

const OrganizationModel = (data) =>
  _.defaults(data || {}, {
    name: "",
    address: {
      street: "",
      city: "",
      state: "",
      zip: "",
    },
    logo: "",
  });

export default OrganizationModel;
